module.exports = __webpack_public_path__ + "static/img/SL.c1884b49.png";